var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createEvent, createStore } from "effector";
import { emptyState, emptyPhoneVerifyStatus, } from "reliance-private-survey-parser/dist/surveyParseTypes";
import { doParseSurvey, parseQuestionAnswer, doSetQuestionIndexes, } from "reliance-private-survey-parser/dist/surveyParseUtils";
import { convertSurvey, matchSurvey } from "../stores/SiteStore";
import { Md5 } from "ts-md5";
import { doStashAnswers, doSurveyInit, doSendVerifyCode } from "../util/common-utilities";
export var setFillContext = createEvent();
export var modifyStorageAnswerDetails = createEvent();
export var goBackDuringInit = createEvent();
export var goBackDuringMatch = createEvent();
export var parseSurvey = createEvent();
export var parseCurrentQuestion = createEvent();
export var setSurveyEnv = createEvent();
export var stashAnswers = createEvent();
export var sendVerifyCode = createEvent();
export var surveyMatch = createEvent();
export var surveyInit = createEvent();
export var updateVerifyStatus = createEvent();
export var resetVerifyStatus = createEvent();
var debounce = function (fn, ms) {
    if (ms === void 0) { ms = 400; }
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { return fn.apply(_this, args); }, ms);
    };
};
var debouncedParseSurvey = debounce(function (x) { return parseCurrentQuestion(x); });
// /// debounce and watch state when answers change
modifyStorageAnswerDetails.watch(function (x) {
    debouncedParseSurvey(x);
});
// /// initial load parse
setFillContext.watch(function () { return parseSurvey(); });
//// STORE
export default createStore(emptyState)
    .on(stashAnswers, function (state) {
    doStashAnswers(state);
})
    .on(updateVerifyStatus, function (state, details) {
    /// see if incoming number is a match
    if (details.verifyNumber &&
        state.phoneVerifyStatus.code &&
        state.phoneVerifyStatus.status === "SENT" &&
        Md5.hashStr(details.verifyNumber) === state.phoneVerifyStatus.code) {
        details.status = "COMPLETED";
        /// if the phone number changed, save it for the submit
        if (state.phoneVerifyStatus.phoneNumber) {
            state.answerStorage["caller_identity"]["phone"] = state.phoneVerifyStatus.phoneNumber;
        }
        convertSurvey({
            surveyFill: state,
            callback: function () { },
        });
    }
    return __assign(__assign({}, state), { phoneVerifyStatus: __assign({}, details) });
})
    // .on(surveyMatch, (state) => {
    //     doSurveyMatch(state);
    // })
    .on(sendVerifyCode, function (state) {
    doSendVerifyCode(state);
})
    .on(surveyInit, function (state, site_store) {
    doSurveyInit(site_store, state);
})
    .on(resetVerifyStatus, function (state) {
    return __assign(__assign({}, state), { phoneVerifyStatus: emptyPhoneVerifyStatus });
})
    .on(setFillContext, function (state, payload) {
    return __assign(__assign({}, state), payload);
})
    .on(setSurveyEnv, function (state, payload) {
    state.env = payload.env;
    state.debug = payload.debug;
    return __assign({}, state);
})
    .on(goBackDuringMatch, function (state) {
    if (state.surveyParseStatus.nextToAnswer && state.surveyParseStatus.previousToAnswer) {
        /// need to nullify the answers for current
        for (var _i = 0, _a = Object.keys(state.answerStorage[state.surveyParseStatus.nextToAnswer]); _i < _a.length; _i++) {
            var fieldName = _a[_i];
            if (!["id", "questionToken", "answerType", "__typename"].includes(fieldName)) {
                state.answerStorage[state.surveyParseStatus.nextToAnswer][fieldName] = null;
            }
        }
        // reset status of the question we just nullified
        parseQuestionAnswer(state, state.surveyParseStatus.nextToAnswer);
        /// need to set the previous to unanswerd
        state.questionStatusStorage[state.surveyParseStatus.previousToAnswer].answered = false;
        doSetQuestionIndexes(state);
        parseQuestionAnswer(state, state.surveyParseStatus.nextToAnswer);
    }
    return __assign({}, state);
})
    .on(goBackDuringInit, function (state) {
    /// get Question Tokens (current/prev)
    var onMatchQuestionToken = state.matchQuestions[state.matchQuestions.length - 1].questionToken;
    /// need to nullify the answers for current
    for (var _i = 0, _a = Object.keys(state.answerStorage[onMatchQuestionToken]); _i < _a.length; _i++) {
        var fieldName = _a[_i];
        if (!["id", "questionToken", "answerType", "__typename"].includes(fieldName)) {
            state.answerStorage[onMatchQuestionToken][fieldName] = null;
        }
    }
    // reset status of the question we just nullified
    parseQuestionAnswer(state, onMatchQuestionToken);
    /// remove current matchQuestion from stack to send it back to previous
    state.matchQuestions.pop();
    state.surveyParseStatus.dq = false;
    state.surveyParseStatus.answered = false;
    return __assign({}, state);
})
    .on(modifyStorageAnswerDetails, function (state, payload) {
    var fieldNameList = payload.fieldName.split("#id#");
    var fieldName = fieldNameList[0];
    // check if it's an array and initialize if needed
    if (fieldName.includes(".")) {
        var fnSplit = fieldName.split(".");
        if (state.questionStorage[payload.questionToken].questionType === "MultiQuestion") {
            if (state.answerStorage[payload.questionToken][fnSplit[0]] === undefined ||
                state.answerStorage[payload.questionToken][fnSplit[0]] === null) {
                state.answerStorage[payload.questionToken][fnSplit[0]] = [];
            }
            state.answerStorage[payload.questionToken][fnSplit[0]][fnSplit[1]] = payload.fieldValue;
        }
        else {
            if (state.answerStorage[payload.questionToken][fnSplit[0]] === undefined ||
                state.answerStorage[payload.questionToken][fnSplit[0]] === null) {
                state.answerStorage[payload.questionToken][fnSplit[0]] = [];
            }
            state.answerStorage[payload.questionToken][fnSplit[0]][fnSplit[1]] = payload.fieldValue;
        }
    }
    else {
        /// only allow numbers and dash for ZIP fields
        if (["zip"].includes(fieldName) &&
            payload.fieldValue &&
            (typeof payload.fieldValue === "string" || payload.fieldValue instanceof String)) {
            payload.fieldValue = payload.fieldValue.replace(/[^0-9-]/g, "");
        }
        state.answerStorage[payload.questionToken][fieldName] = payload.fieldValue;
    }
    return __assign({}, state);
})
    .on(parseCurrentQuestion, function (state, payload) {
    parseQuestionAnswer(state, payload.questionToken);
    return __assign({}, state);
})
    .on(parseSurvey, function (state) {
    var _a, _b;
    doParseSurvey(state);
    if (((_a = state.survey) === null || _a === void 0 ? void 0 : _a.status) === "MATCHED") {
        stashAnswers();
    }
    /// AUTO UPDATE TO CONVERT
    if (state.parsed && ((_b = state.survey) === null || _b === void 0 ? void 0 : _b.status) === "INIT" && ["MATCHED"].includes(state.surveyMatchStatus.status)) {
        matchSurvey(state);
    }
    return __assign({}, state);
});
